import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./auth/auth-context";
import NotificationProvider from "./store/notificationsState/notificationProvider";
import SocketsProvider from "./store/socketsState/socketsProvider";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <NotificationProvider>
        <SocketsProvider>
          <App />
        </SocketsProvider>
      </NotificationProvider>
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
